import React from "react";
import { PieChart, Pie, Legend, Tooltip } from "recharts";





export default function AboutChart(props) {
  const data01 = [];
  props.chartData[0].bag.contentItems.map(x =>data01.push({
    name: x.displayText,
    value: x.yPoint
  }));
  return (
   
      props.chartData.map(c => 
        <PieChart width={1000} height={400}>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={data01}
            cx={200}
            cy={200}
            outerRadius={80}
            fill="#8884d8"
            label
          />
          
          <Tooltip />
        </PieChart>
        )
    
  );
}